// @flow
import Notification from '../domain/Notification';

export const listNotifications = (state: any): Notification => {
  return state.ui.notifications;
};



// WEBPACK FOOTER //
// ./src/common/modules/ui/selectors/notificationSelectors.js